import jwt from 'expo-jwt';
import { SupportedAlgorithms } from 'expo-jwt/dist/types/algorithms';

export default function getLocallySignedToken(token: string, secret: string) {
  const decoded = jwt.decode(token, secret, { timeSkew: 30 });

  const encoded = jwt.encode(decoded, secret, {
    algorithm: SupportedAlgorithms.HS256,
  });

  return encoded;
}
